import Schedule from "components/common/candidate/ScheduleCall";

export default Schedule;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/ScheduleCall/index.js